import React, { useState, useEffect } from "react";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap";
import styles from "./NavbarMain.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const NavbarMain = () => {
  const [show, setShow] = useState(false);
  const [activeNav, setActiveNav] = useState([true, false, false, false]);
  const [expand, setExpand] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Add this style block at the top of your component
  useEffect(() => {
    // Add a style tag to the document head for direct styling
    const style = document.createElement('style');
    style.innerHTML = `
      .navbar-toggler-icon {
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%23fecb02' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e") !important;
      }
    `;
    document.head.appendChild(style);

    // Clean up function to remove the style tag when component unmounts
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const closeNav = () => {
    setExpand(false);
  };

  const showDropdown = (e) => {
    setShow(!show);
  };

  const hideDropdown = (e) => {
    setShow(false);
  };

  useEffect(() => {
    if (sessionStorage.getItem("NavbarMain") != null) {
      let temp = JSON.parse(sessionStorage.getItem("NavbarMain"));
      setActiveNav([...temp]);
    }
  }, []);

  const handleActiveNav = (i) => {
    let temp = activeNav;
    temp = temp.map((x) => (x = false));
    temp[i] = true;
    setActiveNav([...temp]);
    sessionStorage.setItem("NavbarMain", JSON.stringify(temp));
  };

  // Function to scroll to section or navigate to external link
  const scrollToSection = (sectionId, index) => {
    if (location.pathname !== "/") {
      // If not on home page, navigate to home first
      navigate("/");
      // Need to wait for navigation to complete before scrolling
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    } else {
      // Already on home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
    handleActiveNav(index);
    closeNav();
  };

  // Function to handle WhatsApp link
  const goToWhatsApp = () => {
    window.open("https://wa.me/6281220209068", "_blank");
    handleActiveNav(3);
    closeNav();
  };

  return (
    <>
      <Navbar
        style={{
          backgroundColor: "rgba(40, 40, 43, 0.8)", // Change this line for transparency
          boxShadow: "1px 1px 10px rgb(0 0 0 / 0.4)",
        }}
        variant="light"
        expand="lg"
        sticky="top"
        onToggle={() => {
          setExpand((prevState) => !prevState);
        }}
        expanded={expand}
      >
        <Container>
          <Navbar.Brand
            className={styles.logo}
            onClick={() => scrollToSection("banner-section", 0)}
            style={{ cursor: "pointer" }}
          >
            <img
              src={require("../../assets/home/balemartlogo.png")}
              alt="Balemart Logo"
              style={{ height: "40px" }}
            />
          </Navbar.Brand>

          <Navbar.Toggle 
            aria-controls="basic-navbar-nav" 
            // Apply inline styles directly to ensure the SVG color change
            style={{
              '--bs-navbar-toggler-icon-bg': `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%23fecb02' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e")`
            }}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav style={{ marginLeft: "auto" }}>
              <Nav.Link
                className={`${styles.nav_text} ${
                  activeNav[0] ? styles.active : ""
                }`}
                style={{ marginTop: "8px", cursor: "pointer" }}
                onClick={() => scrollToSection("banner-section", 0)}
              >
                Home
              </Nav.Link>

              <Nav.Link
                className={`${styles.nav_text} ${
                  activeNav[1] ? styles.active : ""
                }`}
                style={{ marginTop: "8px", cursor: "pointer" }}
                onClick={() => scrollToSection("about-section", 1)}
              >
                Tentang Kami
              </Nav.Link>

              <NavDropdown
                show={show}
                onMouseEnter={showDropdown}
                onMouseLeave={hideDropdown}
                className={`nav-link ${styles.drop}`}
                title={
                  <span
                    style={{ cursor: "pointer" }}
                    className={styles.dropicon}
                    onClick={() => scrollToSection("services-section", 2)}
                  >
                    <span
                      className={`${styles.nav_text} my-auto ${
                        activeNav[2] ? styles.active : ""
                      }`}
                    >
                      Produk
                    </span>
                  </span>
                }
                id="basic-nav-dropdown"
              >
                <NavDropdown.Item className={styles.dropdownItem}>
                  <span
                    onClick={() => scrollToSection("services-section", 2)}
                    className={styles.dropdownText}
                  >
                    Bahan Bangunan
                  </span>
                </NavDropdown.Item>
                <NavDropdown.Item className={styles.dropdownItem}>
                  <span
                    onClick={() => scrollToSection("services-section", 2)}
                    className={styles.dropdownText}
                  >
                    Bahan Alam
                  </span>
                </NavDropdown.Item>
                <NavDropdown.Item className={styles.dropdownItem}>
                  <span
                    onClick={() => scrollToSection("services-section", 2)}
                    className={styles.dropdownText}
                  >
                    Besi
                  </span>
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link
                className={`${styles.nav_text} ${
                  activeNav[3] ? styles.active : ""
                }`}
                style={{ marginTop: "8px", cursor: "pointer" }}
                onClick={goToWhatsApp}
              >
                Hubungi Kami
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default NavbarMain;